"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toSliderVisualsSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toSliderVisualsSlice = function (data, logger) {
    var slides = toSlides(data, logger);
    // Test des champs obligatoires
    if (!slides) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toAnchoredSlice(data, types_1.SliceType.SliderVisuals)), { slides: slides }));
};
exports.toSliderVisualsSlice = toSliderVisualsSlice;
var toSlides = function (data, logger) {
    var slides = data === null || data === void 0 ? void 0 : data.items.map(function (item) {
        var imageWithCredits = logger.required(field_groups_1.toImageWithCredits(item, logger));
        var imageLink = logger.required(fields_1.toLink(item.imageLink, logger));
        var title = logger.required(fields_1.toText(item.title));
        // Test des champs obligatoires
        if (!imageWithCredits || !title) {
            return null;
        }
        return utils_1.compact({
            imageWithCredits: imageWithCredits,
            imageLink: imageLink,
            title: title,
            text: fields_1.toRichText(item.text, logger)
        });
    }).filter(Boolean);
    return (slides === null || slides === void 0 ? void 0 : slides.length) > 0 ? slides : undefined;
};
//# sourceMappingURL=slider-visuals-slice.js.map